import { HotelPreview } from '../../modules/results/results.container';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterResults',
  // pure: false
})

export class FilterPipe implements PipeTransform {

  transform(hotelPreviews: Array<HotelPreview>, filters): any[] {
      const enbaledStars = this.isStarsEnabled(filters.stars);
    if (hotelPreviews.length === 0) {return []; }
    if (!this.hasFiltersEnabled(filters)) {return hotelPreviews; }

    return hotelPreviews.filter( hotelPreview => {
        if (hotelPreview.offerType !== filters.offerType && !filters.markersMode) { return false; }

        if (enbaledStars) {
            if (filters.stars > hotelPreview.stars) { return false; }
        }

        const hotelTypesExist: Array<number> = filters.hotelTypes.filter(id => hotelPreview.hotelTypes.has(id));
        if (hotelTypesExist.length !== filters.hotelTypes.length) { return false; }

        const mealTypesExist: Array<number> = filters.mealTypes.filter(id => hotelPreview.mealTypes.has(id));
        if (mealTypesExist.length !== filters.mealTypes.length) { return false; }

        const exclusiveCatsExist: Array<number> = filters.exclusiveCategories.filter(id => hotelPreview.exclusiveCategories.has(id));
        if (exclusiveCatsExist.length !== filters.exclusiveCategories.length) { return false; }

        const optionalFacilitiesExist: Array<number> = filters.optionalFacilities.filter(id => hotelPreview.optionalFacilities.has(id));
        if (optionalFacilitiesExist.length !== filters.optionalFacilities.length) { return false; }

        if (filters.priceRange[0] > hotelPreview.minPrice || filters.priceRange[1] < hotelPreview.minPrice) { return false; }

        return true;
    });
   }

   hasFiltersEnabled (filters) {
       if (filters.priceRange.length > 0 || this.isStarsEnabled(filters.stars) || filters.offerType !== undefined) { return true; }
       if (filters.hotelTypes.length === 0 && filters.mealTypes.length === 0
        && filters.exclusiveCategories.length === 0 && filters.optionalFacilities.length === 0) {
            return false;
        }

        return true;
   }

   isStarsEnabled(stars) {
        if (stars === 0) { return false; }
        if (stars === undefined || stars === null) {return false; }
        return true;
   }
}
